export class SplashMap {
    has_splash_screen: boolean = false;
    splash_screen_type: string = 'DEFAULT';
    splash_duration: number = 1000;
    splash_remove_app_branding: boolean = false;

    splash_has_header: boolean = true;
    splash_has_header_text_top = true;
    splash_has_header_text_bottom = true;
    splash_header_text_top: string = null;
    splash_header_text_bottom: string = null;
    splash_header_image_cm_id: string = null;

    splash_has_footer = true
    splash_has_footer_text_top = true
    splash_has_footer_text_bottom = true
    splash_footer_text_top: string = null;
    splash_footer_text_bottom: string = null;
    splash_footer_image_cm_id: string = null;

    splash_has_custom_bg_color = false
    splash_custom_bg_color: string = null;
    splash_has_custom_text_color = false
    splash_custom_text_color: string = null;

}


// WEBPACK FOOTER //
// /app/src/app/core/models/splash-map.ts